module.exports = __webpack_public_path__ + "static/img/delete.7419ecf9.svg";